(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldEmailVerifyElement', fbFieldEmailVerifyDirective);

    function fbFieldEmailVerifyDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldSimpleDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldEmailVerify',
            link: fbFieldEmailVerifyDirectiveLink
        };

        function fbFieldEmailVerifyDirectiveLink(scope, elem) {
            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }
        }
    }

    function fbFieldSimpleDirectiveCtrl(FormBuilderService, $scope, GenericModel, lodash, $rootScope, $interval) {
        var vm = this;
        var formIdentifier = '';
        var spam_protection = false;
        var start_protection_on_load = false;
        var duration = 0;

        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.options = lodash.get($scope.vm.pageData.currentScope.$parent.$parent, 'vm.panelState.structure.options', {});

            vm.showOtpState = lodash.get(vm.options, 'showOtpState', false);
            vm.element.loading = false;
            vm.sendOtp = sendOtp;
            vm.registerProtection = registerProtection;
            // vm.loadHasFieldError = false;
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;

            vm.expired_in = lodash.get(vm.options, 'otp_validity_mins', 0);

            lodash.set(vm.pageData.model, 'txt_otp', null);
            spam_protection = lodash.get(vm.element, 'attr.spam_protection', false);
            start_protection_on_load = lodash.get(spam_protection, 'start_on_load', false);
            duration = lodash.get(vm.options, 'last_sent_threshold', 0);
            vm.is_protected = start_protection_on_load;
            vm.protection_remaining = 0;

            if (start_protection_on_load) {
                registerProtection();
            }

            $scope.otpInput={
                size:6,
                type:"text",
                style: {
                    lineColor   : "#FFFFFF",
                    bgColor     : "#FFFFFF",
                    fontSize    : "14px",    
                },
                onDone: function(value){
                    console.log('on done :'+value);
                },
                onChange: function(value){
                    console.log('on change :'+value);
                    lodash.set(vm.pageData.model, 'txt_otp', value);
                },
            };
        }

        function showOtpWindow() {
            vm.pageData.elementsService.clearElementValidationRule(vm.element.elementIdentifier);
    
            vm.showOtpState = true;
            registerProtection();      

        }

        function registerProtection() {
            if (!!spam_protection) {
                vm.is_protected = true;
                vm.protection_remaining = duration;
                vm.protection_interval = $interval(function () {
                    if (vm.protection_remaining > 0) {
                        vm.protection_remaining = vm.protection_remaining - 1;
                    } else {
                        vm.is_protected = false;
                        $interval.cancel(vm.protection_interval);
                    }
                }, 1000);
            }
        }

        function hasFieldError(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.has(error_rules, 0, false);             
        }

        function fieldErrorMessage(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.get(error_rules, 0, '');
        }

        function sendOtp() {
            vm.element.loading = true; 
            if (lodash.has(vm.element, 'options.datasource.url')) {
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {      
                    if (res) {  
                        if (res.success) {
                            showOtpWindow();
                        }
                    }
                });
            }
        }

        function callRemoteApi() {
            vm.pageData.elementsService.clearValidationSummary(formIdentifier);
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'post');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys', null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }

            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res      
                vm.element.loading = false;
                if (res.success && res.status_code == 200) {
                    return res;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails model. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {   
                vm.element.loading = false;        
                if (res) { 
                    if (res.data.summary) {
                        vm.pageData.elementsService.setValidationSummary(formIdentifier, [res.data.summary], false);

                    }
                    else if (res.data.status_code == 422 && !res.data.summary) {
                        var error_msg = res.data.rules.txt_email_verify;
                        vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, error_msg, true);
                    }                    
                }
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails throw. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console                
                vm.element.loading = false;
                return null;
            });
            
        }
    }    
})();
